export default function parseOriginTable(source, geoid) {
  if (!source) return;

  return {
    ...source,
    data: source.data.replaceAll("{geoid}", geoid),
  };
}
